import * as Yup from "yup";

import { emailValidation } from "../../../../../services/formValidation.service";

export default Yup.object().shape({
  ...emailValidation,
});
